import { Box, Rhythm, Text } from '@trmediaab/zebra';
import { isToday } from 'date-fns';
import { connect } from 'react-redux';

import {
  selectError,
  selectLoading,
  selectRounds,
} from '~/components/Page/RoundNavigation/selectors';

import RoundItem from './RoundItem';

// Logic for sorting the rounds.
// Position [0]: Todays round, can be any round.
// Position [1]: Next V75-round.
// Position [2]: All the other active rounds sorted based on date.
// NOTE: If todays round is a V75-round, return the default array.

export const sortRounds = rounds => {
  if (rounds?.some(round => round.bet_type === 'V75')) {
    const firstRound = rounds[0];
    const firstV75 = rounds.find(round => round.bet_type === 'V75');

    return isToday(new Date(firstRound.start_time)) &&
      firstRound.bet_type !== 'V75'
      ? [
          firstRound,
          firstV75,
          ...rounds.slice(1).filter(round => round.slug !== firstV75.slug),
        ]
      : !isToday(new Date(firstRound.start_time)) &&
          firstRound.bet_type !== 'V75'
        ? [firstV75, ...rounds.filter(round => round.slug !== firstV75.slug)]
        : rounds;
  }

  return rounds;
};

function RoundList({ loading, error, rounds }) {
  if (loading || error) {
    return null;
  }

  return (
    <Box pt="42px" /* Visually aligns with round header  */>
      <Text fontSize={3} fontWeight="bold">
        Aktuella omgångar
      </Text>

      <Rhythm between="1" mt="3">
        {sortRounds(rounds).map(round => (
          <RoundItem key={round.id} round={round} />
        ))}
      </Rhythm>
    </Box>
  );
}

const mapStateToProps = (state, props) => {
  const selectors = {
    loading: selectLoading(state, props),
    error: selectError(state, props),
    rounds: selectRounds(state, props),
  };

  return selectors;
};

export default connect(mapStateToProps)(RoundList);
